import './index.css';
import './assets/sass/theme.scss';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import 'bootstrap/dist/css/bootstrap.css';

const container = document.getElementById('root');
const root = createRoot(container as HTMLElement);
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
root.render(<App />);
